import React, { useEffect, useState } from "react";
import { socket } from "../../../lib/socketio";
import LiveChartsPlot from "./LiveChartsPlot";
import { Button, Grid } from "semantic-ui-react";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC } from "../../../actions/headerActions";

// update 221109 Add Restart DataLayer button

const LiveCharts = () => {
  const [chartList, setChartList] = React.useState(["chart0"]);
  const chartIndex = React.useRef(1);
  const [tags, setTags] = useState([]);
  const [data, setData] = useState([]);
  const chartName = "chart";

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();

  useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names for charts");
      socket.on("receive tag names for charts", (data) => {
        setTags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);
  // }}); // deps 추가 안 할 경우 Dropdown에 tags 값 바로 렌더링 됨. -> // ! Cleanup함수 동작 되는지 확인 필요함.

  const tagsArr = tags.map((el) => {
    // 220825 : key, text, value Dropdown에 필수 요소
    return {
      key: el.id,
      text: el.name,
      yAxisId: "",
      value: el.id,
      value1: data[el.id],
    };
  });

  const handleAddClick = (e) => {
    e.preventDefault();
    setChartList([...chartList, chartName + chartIndex.current]);
    // ? 230126 refactoring : const chartName 변수 삭제해도 될 경우 아래 코드 적용
    // setChartList([...chartList, 'chart'+chartIndex.current]);
    chartIndex.current += 1;
  };

  return (
    <div>
      <h1 style={styles.header}>Live Charts</h1>
      <div style={styles.div}>
        <Grid style={styles.div}>
          <Grid.Row style={{ justifyContent: "left" }}>
            <Button onClick={handleAddClick} color="green">
              Add Chart
            </Button>
            {/* <a href="test://">
                            <Button color='grey' content='Restart DataLayer' />
                        </a> */}
          </Grid.Row>
          <Grid.Row>
            <div style={styles.div}>
              {chartList.map((c, i) => (
                <LiveChartsPlot
                  key={chartList[i]}
                  id={chartList[i]}
                  chartList={chartList}
                  setChartList={setChartList}
                  tags={tags}
                  setTags={setTags}
                  tagsArr={tagsArr}
                  data={data}
                  setData={setData}
                />
              ))}
            </div>
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "5px",
    textAlign: "center",
  },
  grid: {
    marginLeft: "10px",
  },
};

export default LiveCharts;
